import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { OriginalInputState } from '../../types';
import { SupportedLanguage } from '@/domains/translate-bot/enums';
import { OriginalInputModel } from '../../../translate-bot/models/original-input-model';


@injectable()
export class OriginalInputModelImpl extends AbstractModel<OriginalInputState> implements OriginalInputModel {
    dispose(): void {
        this.update(() => {
            return {
                input: '',
                sourceLang: SupportedLanguage.CN,
                targetLang: SupportedLanguage.EN,
                isSupportLang: true,
                isDetectingLanguage: false,
            };
        });
    }

    protected _modelData: OriginalInputState = {
        input: '',
        sourceLang: SupportedLanguage.CN,
        targetLang: SupportedLanguage.EN,
        isSupportLang: true,
        isDetectingLanguage: false,
    };
}
